// @flow
import {createSelector} from "reselect";
import type {State} from "../../Store";

const mapDataSelector = (state: State) => state.mapData;

const isMapReady = createSelector(
    mapDataSelector,
    (mapData) => {
        return mapData.ready;
    }
);

const getMapCenter = createSelector(
    mapDataSelector,
    (mapData) => {
        return mapData.center || {lat: 0, lng: 0};
    }
);

const selectedMapCenter = createSelector(
    mapDataSelector,
    (mapData) => {
        return {shouldPan: mapData.shouldPan, latlng: mapData.latLngToPanTo};
    }
);

const isMapCenterInZone = createSelector(
    mapDataSelector,
    (mapData) => {
        return mapData.isInZone;
    }
);
const getLatLngToPanTo = createSelector(
    mapDataSelector,
    (mapData) => {
        return mapData.latLngToPanTo;
    }
);
const getBoundsToFit = createSelector(
    mapDataSelector,
    (mapData) => {
        return mapData.boundsToFit;
    }
);

export default {
    mapDataSelector,
    isMapReady,
    getMapCenter,
    selectedMapCenter,
    isMapCenterInZone,
    getLatLngToPanTo,
    getBoundsToFit,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/MapData/selectors.js